import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { Schedule, History, Profile } from "./pages";
import { TabNavigation, SurnameModal } from "./components";
import { SurnameModalRef } from "./components/surname-modal";
import {
  ServicesProvider,
  ProfessionalsProvider,
  AppointmentsProvider,
  CommitmentsProvider,
  CustomLunchsProvider,
  WorkingHoursProvider,
  AuthProvider,
  useAuth,
} from "./contexts";
import { hasValidSurname } from "./utils";
import React, { useEffect, useRef } from "react";

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Contexts />}>
          <Route index element={<Schedule />} />
          <Route path="/historico" element={<History />} />
          <Route path="/perfil" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function SurnameModalWrapper({ children }: { children: React.ReactNode }) {
  const { client, isLogged, setClient, refreshClientData } = useAuth();
  const surnameModalRef = useRef<SurnameModalRef>(null);
  const checkedClientId = useRef<string | null>(null);

  useEffect(() => {
    // Verifica se o cliente está logado e não tem sobrenome válido
    // Só verifica se ainda não verificamos este cliente específico
    if (isLogged && client?.id) {
      const clientId = client.id;
      
      // Se mudou o cliente, reseta a verificação
      if (checkedClientId.current !== clientId) {
        checkedClientId.current = clientId;
        
        if (!hasValidSurname(client.name)) {
          // Aguarda um pouco para garantir que a UI está renderizada
          setTimeout(() => {
            surnameModalRef.current?.open(client, async () => {
              // Callback executado após salvar o sobrenome na modal
              // Atualiza os dados do cliente no contexto
              await refreshClientData();
            });
          }, 500);
        }
      }
    }
    
    // Reset quando o cliente não estiver mais logado
    if (!isLogged) {
      checkedClientId.current = null;
    }
  }, [client?.id, client?.name, isLogged, refreshClientData, setClient]);

  return (
    <>
      <SurnameModal
        ref={surnameModalRef}
        loading={false}
      />
      {children}
    </>
  );
}

function Contexts() {
  return (
    <AuthProvider>
      <ServicesProvider>
        <ProfessionalsProvider>
          <AppointmentsProvider>
            <CommitmentsProvider>
              <CustomLunchsProvider>
                <WorkingHoursProvider>
                  <SurnameModalWrapper>
                    <TabNavigation>
                      <Outlet />
                    </TabNavigation>
                  </SurnameModalWrapper>
                </WorkingHoursProvider>
              </CustomLunchsProvider>
            </CommitmentsProvider>
          </AppointmentsProvider>
        </ProfessionalsProvider>
      </ServicesProvider>
    </AuthProvider>
  );
}

export default Router;
